import { render, staticRenderFns } from "./consulta.vue?vue&type=template&id=12f02058"
import script from "./consulta.ts?vue&type=script&lang=js&external"
export * from "./consulta.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f02058')) {
      api.createRecord('12f02058', component.options)
    } else {
      api.reload('12f02058', component.options)
    }
    module.hot.accept("./consulta.vue?vue&type=template&id=12f02058", function () {
      api.rerender('12f02058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/devolucaocompra/consulta.vue"
export default component.exports